// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3esAj","questions":"styles_questions__2lGHd","footer":"styles_footer__3lvQ7"};